import React from 'react';
import TraversalDirection from '../../../atoms/Traversal/Traversal';
import { AtlasViewContext } from '../../../organisms/AtlasComponent/AtlasViewContext';
import './NodeCounts.scss';

interface NodeCountsProps {
  completePill?: boolean;
  counts: number;
  sphereId: string;
  level: number;
  onEdgeCountClick: (sphereId: string) => void;
  traversalDirection: 'outwards' | 'inwards' | 'both';
  onTraversalDirectionClick?: (
    sphereId: string,
    direction: 'outwards' | 'inwards' | 'both',
    level: number
  ) => void;
  width?: string;
}

const NodeCounts: React.FC<NodeCountsProps> = ({
  completePill,
  counts,
  sphereId,
  level,
  onEdgeCountClick,
  traversalDirection,
  onTraversalDirectionClick,
  width,
}) => {
  const context = React.useContext(AtlasViewContext);
  const { showNearbyNodeCount, allowTraversalDirectionChange } = context?.viewConfig ?? {};
  const shouldShowCount = showNearbyNodeCount !== false;

  return (
    <div
      className={`node-counts ${completePill ? 'complete-pill' : ''}`}
      style={{
      width: width ?? 'auto',
      cursor: 'pointer',
      // Fully rounded when standalone; square left only when it visually connects to a
      // NodePerspectivePill on its left (decided by the parent via completePill).
      borderRadius: completePill ? '20px' : '0px 20px 20px 0px',
      }}
    >
      {shouldShowCount && (
      <span
        className="pl-1"
        role="button"
        tabIndex={0}
        onClick={(e) => {
        e.stopPropagation();
        onEdgeCountClick(sphereId);
        }}
        onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation();
          onEdgeCountClick(sphereId);
        }
        }}
      >
        {counts}
      </span>
      )}
      {allowTraversalDirectionChange && (
        <span>
          <TraversalDirection
            direction={traversalDirection}
            onClick={(newDirection) =>
              onTraversalDirectionClick?.(sphereId, newDirection, level)
            }
          />
        </span>
      )}
    </div>
  );
};

export default NodeCounts;
